import React from 'react';
import { Typography } from '@mui/material';
import { capitalize } from 'lodash';
import Spinner from '../../../assets/svg/spinner';
import { useTimeFormatters } from '../../../utils/Hooks/venue/useVenueTimeFormatters';

import {
  ComplementaryText,
  MissedText,
  ScheduleContainer,
  ScheduleItemRow,
  ScheduleItemValue,
  StyledBox,
  StyledEmptyBox,
  SubtitleText,
} from './ViolationScheduleInfo.styles';

const ViolationScheduleInfo = ({
  status,
  shiftDetails,
  breakDetails,
  isBreakViolation,
  isLoading,
  isMissedViolation,
}) => {
  const { formatTime } = useTimeFormatters();
  // Destructure the violation details
  const {
    start: shiftScheduledStart,
    end: shiftScheduledEnd,
    clockedInAt: shiftActualStart,
    clockedOutAt: shiftActualEnd,
  } = shiftDetails || {};
  const {
    scheduledStart: breakScheduledStart,
    scheduledEnd: breakScheduledEnd,
    start: breakActualStart,
    end: breakActualEnd,
  } = breakDetails || {};

  const scheduledStart = isBreakViolation ? breakScheduledStart : shiftScheduledStart;
  const scheduledEnd = isBreakViolation ? breakScheduledEnd : shiftScheduledEnd;
  const actualStart = isBreakViolation ? breakActualStart : shiftActualStart;
  const actualEnd = isBreakViolation ? breakActualEnd : shiftActualEnd;

  return (
    <StyledBox>
      {isLoading ? (
        <StyledEmptyBox>
          <Spinner />
        </StyledEmptyBox>
      ) : (
        <ScheduleContainer>
          <ScheduleItemRow>
            <SubtitleText>
              <Typography variant="bodyRegular"> {`${isBreakViolation ? 'Break' : 'Shift'} start`}</Typography>
              <ComplementaryText variant="subheadlineRegular">{`Scheduled at ${formatTime(scheduledStart)}`}</ComplementaryText>
            </SubtitleText>
            <ScheduleItemValue>
              <Typography variant="bodyRegular">
                {isMissedViolation ? (
                  <MissedText variant="bodyRegular">Missed</MissedText>
                ) : isBreakViolation ? (
                  actualStart ? (
                    formatTime(actualStart)
                  ) : (
                    'N/A'
                  )
                ) : actualStart ? (
                  formatTime(actualStart)
                ) : (
                  'N/A'
                )}
              </Typography>
            </ScheduleItemValue>
          </ScheduleItemRow>

          <ScheduleItemRow>
            <SubtitleText>
              <Typography variant="bodyRegular">{`${isBreakViolation ? 'Break' : 'Shift'} end`}</Typography>
              <ComplementaryText variant="subheadlineRegular">{`Scheduled at ${formatTime(scheduledEnd)}`}</ComplementaryText>
            </SubtitleText>
            <ScheduleItemValue>
              <Typography variant="bodyRegular">
                {isMissedViolation ? (
                  <MissedText variant="bodyRegular">Missed</MissedText>
                ) : isBreakViolation ? (
                  actualEnd ? (
                    formatTime(actualEnd)
                  ) : (
                    'N/A'
                  )
                ) : actualEnd ? (
                  formatTime(actualEnd)
                ) : (
                  'N/A'
                )}
              </Typography>
            </ScheduleItemValue>
          </ScheduleItemRow>

          <ScheduleItemRow>
            <SubtitleText>
              <Typography variant="bodyRegular">Violation Status</Typography>
            </SubtitleText>

            <ScheduleItemValue>
              <Typography variant="bodyRegular">{capitalize(status)}</Typography>
            </ScheduleItemValue>
          </ScheduleItemRow>
        </ScheduleContainer>
      )}
    </StyledBox>
  );
};

export default ViolationScheduleInfo;
